<template>
  <div>
    <el-dialog
      :visible.sync="isConfirmRefund"
      width="400px"
      center
      append-to-body
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="refund-title" slot="title">退款提示</div>
      <div class="refund-des">
        <div>退款原因：{{reason}}</div>
        <div v-if="row.oilInvoiceStatus === 1">此订单已开票成功，确定要退款给车主吗？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="isConfirmRefund = false">取 消</el-button>
        <el-button class="true-btn" @click="confirmRefundOrder">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { confirmRefund } from '@/api/order'
export default {
  props: {
    row: {
      type: Object
    }
  },
  data () {
    return {
      btnLoading: false,
      isConfirmRefund: false,
      reason: ''
    }
  },
  methods: {
    init (reason) {
      this.isConfirmRefund = true
      this.reason = reason
    },
    // 确认退款
    async confirmRefundOrder () {
      const { gasId, orderId, applySourceType } = this.row
      const params = {
        gasId,
        orderId,
        applySourceType
      }
      try {
        const { code, message } = await confirmRefund(params)
        if (code === 13560) {
          this.$alert(message, '退款异常提示', { confirmButtonText: '知道了', type: 'warning' })
          return
        }
        if (code !== 200) return this.$message.error(message || '退款失败')
        this.$message.success('退款成功')
        this.$emit('handleConfirmRefund')
        // this.setOrderType(name)
      } catch (error) {
        console.log(error.message)
      } finally {
        this.isConfirmRefund = false
        this.$emit('handleConfirmRefund')
        // this.setOrderType(name,1)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.refund-des{
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding: 18px 0;
  color: #666666;
  >div:nth-child(2){
    padding-top: 10px;
  }
}
.refund-title{
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222222;
}
.cancel-btn{
  width: 100px;
  height: 40px;
  border-radius: 1px;
  border: 1px solid #C5C9D0;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.true-btn{
  width: 100px;
  height: 40px;
  text-align: center;
  background: #4B7EFE;
  box-shadow: 0px 1px 4px 0px rgba(16,67,193,0.2);
  border-radius: 1px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-shadow: 0px 1px 4px rgba(16, 67, 193, 0.2);
}
</style>